import React from "react";
import Score from '../results/Score';
import {processStats, performanceGain} from '../../utils/calculator';
import usFlag from '../../images/usa@2x.png';
import deFlag from '../../images/ger@2x.png';
import brFlag from '../../images/bra@2x.png';
import auFlag from '../../images/aus@2x.png';
import jpFlag from '../../images/jpn@2x.png';
import resultTypes from '../../data/results';

export default class Report extends React.Component {
  componentDidMount() {
    // Ugly hack
    document.body.className = "is-report";
    window.prerenderReady = true;
  }

  render() {
    const {results} = this.props;
    const stats = processStats(results);

    return <div className="report">
      <div className="report-screen">
        <header className="report-header">
          <h1 className="report-title">Performance and Security Test For:</h1>
          <h2 className="report-url">{stats.url || "Hello"}</h2>
        </header>

        <div className="report-row">
          <div className="report-col-3">
            <h3>Introduction</h3>
            <p><strong>Testmysite.io rates your site based on its initial global load times and its security settings.</strong></p>
          </div>
        </div>

        <div className="report-row">
          <div className="report-col-2">
            <div className="report-row">
              <div className="report-col-2">
                <h3>Overview</h3>
                <ul>
                  <li>Your website is very slow.</li>
                </ul>
              </div>
              <div className="report-col-1">
                <Score stats={stats} condenced={true}/>
              </div>
            </div>
          </div>
          <div className="report-col-1">
            <h3>Did you know?</h3>

            <p>More than 80% of WordPress sites are running outdated security patches, making it vulnerable to external attacks.</p>
          </div>
        </div>

        <div className="report-row">
          <div className="report-col-2">
            <h3>Report Card</h3>
            <ul className="report-list">
              <li>
                <span className="label">Full Download of HTML</span>
                <span className={`value is-${stats.complete_load.status}`}>{stats.complete_load.value}ms</span>
              </li>
              <li>
                <span className="label">TTFB (Time to first byte)</span>
                <span className={`value is-${stats.first_byte.status}`}>{stats.first_byte.value}ms</span>
              </li>
              <li>
                <span className="label">HTTPS</span>
                <span className={`value is-${stats.is_https.status}`}>{stats.is_https.value ? 'YES' : 'NO'}</span>
              </li>
              <li>
                <span className="label">HTTP2</span>
                <span className={`value is-${stats.is_http_2.status}`}>{stats.is_http_2.value ? 'YES' : 'NO'}</span>
              </li>
            </ul>
          </div>
          <div className="report-col-1">
            <h3>If it was on netlify</h3>

            <ul className="report-list report-nf">
              <li>
                <span className="value is-good">{stats.netlify_estimate.value}ms</span>
                {stats.netlify_estimate.value < stats.complete_load.value &&
                    <span className="gain">+{performanceGain(stats.complete_load, stats.netlify_estimate)}%</span>}
              </li>
              <li>
                <span className="value is-good">{stats.netlify_first_byte.value}ms</span>
                {stats.netlify_first_byte.value < stats.first_byte.value &&
                    <span className="gain">+{performanceGain(stats.first_byte, stats.netlify_first_byte)}%</span>}
              </li>
              <li>
                <span className="value is-good">YES</span>
              </li>
              <li>
                <span className="value is-good">YES</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="report-screen">
        <div className="report-row">
          <div className="report-col-3">
            <h3>Stats from Around the World</h3>

            <div className="report-list">
              <table className="report-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <img src={usFlag} className="is-flag" />
                      SF, USA
                    </th>
                    <th>
                      <img src={usFlag} className="is-flag" />
                      NY, USA
                    </th>
                    <th>
                      <img src={deFlag} className="is-flag" />
                      FR, GER
                    </th>
                    <th>
                      <img src={brFlag} className="is-flag" />
                      SP, BRA
                    </th>
                    <th>
                      <img src={auFlag} className="is-flag" />
                      SY, AUS
                    </th>
                    <th>
                      <img src={jpFlag} className="is-flag is-jp" />
                      TO, JPN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(resultTypes).map((key) => resultTypes[key].type === "number" && <tr>
                    <td>{resultTypes[key].label}</td>
                    {Object.keys(stats[key].locations).map((loc) => <td className="">
                      {stats[key].locations[loc]}ms
                    </td>)}
                  </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="report-screen">
        <div className="report-row">
          <div className="report-col-half">
            <div className="report-row">
              <div className="repot-col-3">
                <h3>FULL DOWNLOAD OF HTML</h3>
                <p>Time it takes the user's browser to download the full HTML page (additional components, Javascript and events won't load before this happens). Affects your page load speed significantly, which affects google search ranking, bouncerates and conversions.</p>
              </div>

            </div>
            <div className="report-row">
              <div className="repot-col-3">
                <h3>CONNECTION TIME</h3>
                <p>Time it takes for a user's browser to connect to your site's IP address. Affects your page load speed, which affects google search ranking, bouncerates and conversions.</p>
              </div>
            </div>
            <div className="report-row">
              <div className="repot-col-3">
                <h3>HTTP2 SUPPORT</h3>
                <p>Enabling HTTP2 will make your site load faster. HTTP2 is an update to the HTTP protocol engineered to improve performance of the web with consideration for how modern web applications are built.</p>
              </div>
            </div>
            <div className="report-row">
              <div className="repot-col-3">
                <h3>HTTPS SUPPORT</h3>
                <p>Google's search index gives preferential ranking to sites secured with HTTPs, and proposals are in place to mark standard HTTP sites as insecure. For additional reasons HTTPS is important, see [Five Reasons You Want HTTPS for your Static Site](https:// www.netlify.com/blog/2014/10/03/five- reasons-you-want-https-for-your-static-site).</p>
              </div>
            </div>
          </div>
          <div className="report-col-half">
            <div className="report-row">
              <div className="repot-col-3">
                <h3>TTFB (TIME TO FIRST BYTE)</h3>

                <p>Time it takes for the user's browser to begin receiving your website. Affects your page load speed significantly, which affects google search ranking, bouncerates and conversions.</p>
              </div>
            </div>
            <div className="report-row">
              <div className="repot-col-3">
                <h3>DNS LOOKUP TIME</h3>
                <p>Time it takes to do a DNS lookup to discover your site's IP address. Affects your page load speed, which affects google search ranking, bouncerates and conversions.</p>
              </div>
            </div>

            <div className="report-row">
              <div className="repot-col-3">
                <h3>HTTPS HANDSHAKE TIME</h3>
                <p>Time to negotiate the encrypted connection between the browser and the secure site server. Affects your page load speed.</p>
              </div>
            </div>

            <div className="report-row">
              <div className="repot-col-3">
                <h3>VALID SSL CERTIFICATE</h3>
                <p>Testing if the SHA certificate is up-to-date. Some servers use an old encryption mechanism that's no longer secure when using HTTPS. [link to the full SSL test at SSLLabs where they'll be told that their SSL setup is bad and insecure.] An obsolete or broken certificate means your users will get warnings in certain browsers.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
};



// WEBPACK FOOTER //
// ./src/components/report/ReportPage.js